<template>
  <div>
    <form @submit.prevent="postMessage">
      <div class="columns">
        <div class="column">
          <b-field>
            <b-input
              placeholder="Type your message here..."
              size="is-medium"
              v-model="message"
            ></b-input>
          </b-field>
        </div>
        <div class="column is-one-fifth">
          <b-button
            native-type="submit"
            type="is-primary"
            size="is-medium"
            class="is-fullwidth"
            :loading="busy"
            :disabled="busy || !isValid"
          >Post</b-button>
        </div>
      </div>
    </form>
    <div class="pt-lg">
      <!-- No Messages -->
      <div v-if="!refreshing && messages.length === 0">
        <p class="has-text-centered has-text-grey py-lg">No messages have been posted.</p>
      </div>
      <!-- Has Messages -->
      <div v-else>
        <message class="mb-sm pt-sm border-t" v-for="message in publicMessages" :og-message="message" :key="message.id" />
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import Message from './Message'
export default {
  components: {
    Message
  },
  computed: {
    ...mapGetters(['context']),
    busy () {
      return (this.saving || this.refreshing)
    },
    isValid () {
      return (this.message !== null && this.message !== '')
    },
    postEndpoint () {
      return this.context.route + '/orders/' + this.order.id + '/memos/'
    },
    postBody () {
      return {
        text: this.message
      }
    },
    publicMessages () {
      return this.$utils.filter(this.messages, ['visibility', 'any'])
    },
    orderEndpoint () {
      return this.context.route + '/orders/' + this.order.id + '/'
    }
  },
  data () {
    return {
      message: null,
      messages: this.order.memos,
      refreshing: false,
      saving: false
    }
  },
  methods: {
    postMessage () {
      this.saving = true
      this.$http.post(this.postEndpoint, this.postBody).then(response => {
        this.saving = false
        this.message = null
        this.refreshOrder()
      })
    },
    refreshOrder () {
      this.refreshing = true
      this.$http.get(this.orderEndpoint).then(response => {
        // only grab the 'public' messages
        const messages = []
        response.data.memos.forEach(memo => {
          if (memo.visibility === 'any') {
            messages.push(memo)
          }
        })
        this.messages = messages
        this.refreshing = false
      })
    }
  },
  mounted () {

  },
  props: ['order']
}
</script>
